import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";
export const getGenderList = async () => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        apiendpoints.GENDER_ENUM_LIST
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };
export const getTimezoneList = async () => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        apiendpoints.TIMEZONE_ENUM_LIST
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };
export const getEventApplicationRoleList = async () => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        apiendpoints.APPLICATION_ROLE_LIST
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };

  export const getRoleList = async () => {
    try {
      const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
      const response = await axioClient.get(
        apiendpoints.USER_ROLE_ENUM_LIST
      );
      return APICLIENT.handleResponse(response);
    } catch (err) {
      return APICLIENT.handleError(err);
    }
  };